import * as Haptics from 'expo-haptics';
import i18n from '@/utils/i18n';
import React, { useEffect } from 'react';
import { BaseActionSheet } from './base-action-sheet';
import { HappyBox } from './happy-box';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

export interface Props {
  onClose?: () => void;
}

export const QueuedOrdersPlacedActionSheet: React.FC<Props> = ({ onClose }) => {
  useEffect(() => {
    if (Platform.OS !== 'web') {
      Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success);
    }
  }, []);

  return (
    <BaseActionSheet
      contentStyle={styles.content}
      isVisible
      onClose={() => {
        onClose?.();
      }}
      testID="queued-orders-placed-action-sheet"
    >
      <View>
        <HappyBox />
        <Text style={[TYPOGRAPHY.h3, styles.titleText]}>
          {i18n.t('order_placed_action_sheet.title_plural')}
        </Text>
      </View>
    </BaseActionSheet>
  );
};

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: 48,
    paddingTop: 24,
  },
  titleText: {
    marginBottom: 8,
    textAlign: 'center',
  },
});
